import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Tr} from "@/i18n/i18n";
import SpriteUtils from "@/utils/sprite-utils";
import {Keys} from "@/constants/key";
import CU from "@/utils/c-u";
import {InfoPanel} from "@/scenes.ui/info-panel";
import {ArkInfoPanel} from "@/scenes.ui/ark-info-panel";

export class OblivionHeroInfoPanel extends Phaser.GameObjects.Container {

    public static readonly PANEL_HEIGHT = 190;

    constructor(scene: Phaser.Scene, canvas: HTMLCanvasElement) {
        super(scene);

        this.scene = scene;
        this.height = OblivionHeroInfoPanel.PANEL_HEIGHT;
        let self = this;

        let back = SpriteUtils.addImage(this.scene, -300, 0, Keys.OBLIVION_BACK_2, undefined).setOrigin(0, 0);

        let yy = -4;
        let help1 = TextUtils.addTextAdvanced(scene, Tr('ark.hlp.1'), 0, yy += 37,
            '#a3afc9', 13, 'normal', 480, 'center', 2, Fonts.MYRIADPRO_REGULAR);

        let question1 = SpriteUtils.addImage(this.scene!, help1.getTopRight().x! / CU.S + 14, help1.y / CU.S + 1, Keys.ATLAS_UI, Keys.UI_STAT_MINE_CIRCLE, 0.8, 0.8)
        question1.setInteractive().on('pointerup', function() {
            let ip = new ArkInfoPanel(scene, canvas, Tr('ark'), Tr('ark.d.1.1'),
                Tr('ark.d.1.2'),
                Tr('ark.d.1.3'),
                Tr('ark.d.1.4'), () => {});
            ip.openAnimated();
        });

        let help2 = TextUtils.addTextAdvanced(scene, Tr('ark.hlp.2'), 0, yy += 37,
            '#c5d9cb', 13, 'normal', 480, 'center', 2, Fonts.MYRIADPRO_REGULAR);

        let help3 = TextUtils.addTextAdvanced(scene, Tr('ark.hlp.3'), 0, yy += 37,
            '#a3afc9', 13, 'normal', 480, 'center', 2, Fonts.MYRIADPRO_REGULAR);

        let question3 = SpriteUtils.addImage(this.scene!, help3.getTopRight().x! / CU.S + 14, help3.y / CU.S + 1, Keys.ATLAS_UI, Keys.UI_STAT_MINE_CIRCLE, 0.8, 0.8)
        question3.setInteractive().on('pointerup', function() {
            let ip = new InfoPanel(scene, canvas, Tr('ark'), Tr('ark.d.1.1'),
                Tr('ark.d.3'),
                () => {});
            ip.openAnimated();
        });

        let help4 = TextUtils.addTextAdvanced(scene, Tr('ark.hlp.4'), 0, yy += 37,
            '#c5d9cb', 13, 'normal', 480, 'center', 2, Fonts.MYRIADPRO_REGULAR);

        let question4 = SpriteUtils.addImage(this.scene!, help4.getTopRight().x! / CU.S + 14, help4.y / CU.S + 1, Keys.ATLAS_UI, Keys.UI_STAT_MINE_CIRCLE, 0.8, 0.8)
        question4.setInteractive().on('pointerup', function() {
            let ip = new ArkInfoPanel(scene, canvas, Tr('ark'), Tr('ark.d.4.1'),
                Tr('ark.d.4.2'),
                Tr('ark.d.4.3'),
                Tr('ark.d.4.4'), () => {});
            ip.openAnimated();
        });

        this.add([back, help1, question1, help2, help3, question3, help4, question4]);
    }

}
